import { render } from "./DetalharMeioPagamento.vue?vue&type=template&id=2c06a3ac&scoped=true"
import script from "./DetalharMeioPagamento.vue?vue&type=script&lang=js"
export * from "./DetalharMeioPagamento.vue?vue&type=script&lang=js"

import "./DetalharMeioPagamento.vue?vue&type=style&index=0&id=2c06a3ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c06a3ac"]])

export default __exports__